export const needHelpOnCLick = {
    event: "new_menu",
    eventAction: "need_help | select"
};
